<template>
    <div class="ref020-header">
        <!-- 헤더 1줄: utils + 본인 정보 (브랜드는 사이드바로 이동 — hot-fix #20 안건 3) -->
        <div class="ref020-header-row1">
            <!-- hot-fix #20 안건 28 후속 fix (2026-05-08): brand + 도구함 좌측 그룹 wrapper — sidebar collapsed 시 도구함이 가운데 밀려나던 문제 해소 (사용자 발견).
                 좌측 그룹 (brand-area + header-tools) + 우측 영역 = 2 children → space-between 으로 좌측·우측 정렬 정합 -->
            <div class="ref020-header-left">
                <!-- 안건 4 (2026-05-07): 사이드바 collapsed 시 헤더 brand fallback. 사이드바 펼친 상태는 사이드바 좌상 brand 단독 노출.
                     안건 66 (2026-05-12): 비로그인 분기 제거 — public-header.vue 가 별도 컴포넌트로 처리. 본 컴포넌트는 로그인 전용. -->
                <div v-if="sidebarCollapsed" class="ref020-brand-area">
                    <a class="ref020-brand" href="/">
                        <i>✈</i>
                        <span class="ref020-brand-name">GONELO</span>
                        <span class="ref020-brand-tagline">B2B Global Logistics Partner</span>
                    </a>
                </div>

                <!-- hot-fix #20 안건 29 (2026-05-08): 좌측 사이트 링크 (공지사항·결제관리) — 라벨 없이 단순 링크 -->
                <div v-if="linksItems && linksItems.length > 0" class="ref020-header-links">
                    <a v-for="(link, index) in linksItems"
                       :key="'link-' + index"
                       :href="link.url"
                       :target="link.target"
                       :title="link.name"
                       class="ref020-header-links-item">
                        <i v-if="link.icon" class="material-icons">{{ link.icon }}</i>
                        <span>{{ link.name }}</span>
                    </a>
                </div>
            </div>

            <div class="ref020-header-right">
                <!-- hot-fix #20 안건 29 (2026-05-08): 우측 도구함 — 외부 도구 + 계산기 (🛠 도구 라벨 + 카드 패널) -->
                <div v-if="toolsItems && toolsItems.length > 0" class="ref020-header-tools">
                    <span class="ref020-header-tools-label" title="도구">
                        <i class="material-icons">build</i>
                    </span>
                    <a v-for="(tool, index) in toolsItems"
                       :key="'tool-' + index"
                       :href="tool.url"
                       :target="tool.target"
                       :title="tool.name"
                       class="ref020-header-tools-item">
                        <i v-if="tool.icon" class="material-icons">{{ tool.icon }}</i>
                        <span>{{ tool.name }}</span>
                    </a>
                </div>
                <!-- 안건 34 (2026-05-08): 정보 박스 (사서함·예치금·미결제) 별도 그룹 + 사용자 카드 단순화.
                     안건 37 (2026-05-08): 사서함 title + 예치금·미결제 링크.
                     안건 66 (2026-05-12): 본 컴포넌트는 로그인 전용 — `logined` 가드 제거, `loginInfo` 만 체크. -->
                <div v-if="loginInfo" class="ref020-header-info-group">
                    <span v-if="loginInfo.mailbox" class="ref020-info-box ref020-info-mailbox"
                          :title="'내 사서함: ' + loginInfo.mailbox">
                        <i class="material-icons">mail</i>
                        <span>{{ loginInfo.mailbox }}</span>
                    </span>
                    <a class="ref020-info-box ref020-info-deposit ref020-info-link"
                       :class="depositColorClass"
                       :href="loginInfo.deposit_url"
                       :title="'예치금 ' + formatNumber(loginInfo.deposit) + '원 — 입금확인요청'">
                        <i class="material-icons">account_balance_wallet</i>
                        <span>₩{{ formatNumber(loginInfo.deposit) }}</span>
                    </a>
                    <!-- 미결제금 — cnt > 0 시만 노출 (사용자 결정 안건 30) -->
                    <a v-if="loginArrears && loginArrears.cnt > 0" class="ref020-info-box ref020-info-arrears ref020-info-link"
                       :href="loginInfo.arrears_url"
                       :title="'미결제 ' + loginArrears.cnt + '건 / ₩' + formatNumber(loginArrears.totalAmount) + ' — 미결제건 조회'">
                        <i class="material-icons">warning</i>
                        <span>₩{{ formatNumber(loginArrears.totalAmount) }}</span>
                    </a>
                </div>

                <!-- 사용자 카드 — 시안 D: 닉네임 + 아바타 + 화살표만 단순. 클릭 시 uk-dropdown 패널. -->
                <div v-if="loginInfo" class="ref020-user-card" id="app-user-card">
                    <div class="ref020-user-card-avatar">
                        <i class="material-icons">person</i>
                    </div>
                    <div class="ref020-user-card-nick">{{ loginInfo.nick }}</div>
                    <i class="material-icons ref020-user-card-caret">expand_more</i>
                </div>

                <!-- 사용자 드롭다운 패널 — uk-dropdown (트리거 = #app-user-card) -->
                <div v-if="loginInfo" uk-dropdown="mode: click; pos: bottom-right; toggle: #app-user-card; boundary: #app-laoyout-header" class="ref020-user-dropdown">
                    <div class="ref020-user-dropdown-info">
                        <div class="ref020-user-dropdown-nick">{{ loginInfo.nick }}</div>
                        <div class="ref020-user-dropdown-email">{{ loginInfo.email }}</div>
                        <div v-if="loginInfo.mailbox" class="ref020-user-dropdown-mailbox">
                            <i class="material-icons">mail</i>
                            <span>{{ loginInfo.mailbox }}</span>
                        </div>
                        <div class="ref020-user-dropdown-deposit" :class="depositColorClass">
                            예치금 ₩{{ formatNumber(loginInfo.deposit) }}
                        </div>
                        <div v-if="loginArrears && loginArrears.cnt > 0" class="ref020-user-dropdown-arrears">
                            미결제 {{ loginArrears.cnt }}건 / ₩{{ formatNumber(loginArrears.totalAmount) }}
                        </div>
                    </div>
                    <hr class="ref020-user-dropdown-divider" />
                    <div class="ref020-user-dropdown-actions">
                        <a href="/my/user" class="ref020-user-dropdown-link">
                            <i class="material-icons">person</i>
                            <span>내 계정</span>
                        </a>
                        <button type="button" class="ref020-user-dropdown-logout" @click="onLogout">
                            <i class="material-icons">exit_to_app</i>
                            <span>로그아웃</span>
                        </button>
                    </div>
                </div>
                <form id="logout-form" action="/users/logout" method="POST" style="display:none">
                    <input type="hidden" name="_token" :value="csrfToken" />
                </form>
                <!-- 안건 66 (2026-05-12): utils slot 폐기 — 가입/로그인은 public-header.vue 로 이전.
                     기존 _header-utils.blade.php 는 본 컴포넌트에 더이상 주입되지 않음. -->
            </div>
        </div>
    </div>
</template>

<script>
// REF-020 Phase 2-A (2026-05-04) — 신규 헤더 SSOT Vue 컴포넌트
//
// 모든 로그인 페이지가 본 컴포넌트를 강제로 포함 (정책: 헤더는 레이아웃 위에 떠 있는 단일 SSOT).
// 정책 1·결정 12 — 본 컴포넌트는 항상 $login 본인 정보. 라우팅 회원사 정보는 작업 영역 (sidebar/breadcrumb).
//
// 결정 11 (γ) — 비로그인 캡처 + 로그인 시 본인 예치금·미결제 박스 + 사용자 드롭다운 합류
// 결정 17 — 사이드바 토글 (햄버거 ☰), 사이드바 측 ◀ 와 단일 토글
// 안건 66 (2026-05-12) — 본 컴포넌트는 로그인 전용. 비로그인은 별도 app-header-public 사용.
//
// props 인터페이스 (안건 66 후):
//   - loginInfo (Object|null) — 로그인 회원 정보 { nick, email, mailbox, deposit, deposit_url, arrears_url }
//   - loginArrears (Object|null) — 로그인 미결제 { cnt, totalAmount }
//   - linksItems (Array) — 헤더 좌측 사이트 링크 (공지·결제 — 안건 29)
//   - toolsItems (Array) — 헤더 우측 도구함 (계산기·유니패스·통관·take-a-photo — 안건 27·29·64)
//
// 사이드바 토글 — 'sidebar-toggle' event emit. layout 측에서 listen + sidebar.vue 의 collapsed 상태 토글.
//
// REF-020 결정 22 critical — props 에 다른 회원사 정보 들어갈 수 없음 (login* prefix 만, server-side ViewSharing 의 $login 본인 보장)
import formatNumberMixin from './mixins/format-number';

export default {
    name: 'app-header',
    mixins: [formatNumberMixin],
    // 안건 66 (2026-05-12): 본 컴포넌트는 로그인 전용 — `logined`, `loginHasMember` props 제거.
    //   비로그인은 별도 컴포넌트 (app-header-public) 사용. 결정 22 critical 유지: 항상 login* prefix 본인 정보만.
    props: {
        loginInfo: {
            type: Object,
            default: null,
        },
        // hot-fix #20 안건 29 (2026-05-08): 좌측 사이트 링크 (공지사항·결제관리)
        linksItems: {
            type: Array,
            default: () => [],
        },
        // hot-fix #20 안건 27·29 (2026-05-08): 우측 도구함 (외부 도구 + 계산기)
        toolsItems: {
            type: Array,
            default: () => [],
        },
        loginArrears: {
            type: Object,
            default: null,
        },
    },
    data() {
        // hot-fix #20 안건 4 (2026-05-07): sidebarCollapsed reactive — sidebar.vue 와 동일 localStorage 초기값 + listener 로 동기화
        return {
            sidebarCollapsed: (() => {
                try {
                    const saved = window.localStorage.getItem('ref020-sidebar-collapsed');
                    if (saved !== null) return saved === '1';
                } catch (e) { /* localStorage 차단 환경 */ }
                return false;
            })(),
        };
    },
    mounted() {
        this._sidebarCollapsedHandler = (e) => {
            this.sidebarCollapsed = e.detail.collapsed;
        };
        window.addEventListener('ref020-sidebar-collapsed-changed', this._sidebarCollapsedHandler);
    },
    beforeDestroy() {
        window.removeEventListener('ref020-sidebar-collapsed-changed', this._sidebarCollapsedHandler);
    },
    computed: {
        // hot-fix #20 안건 30 (2026-05-08): 예치금 색상 분기 (양수=primary / 음수=danger / 0=muted)
        depositColorClass() {
            const d = this.loginInfo?.deposit || 0;
            if (d > 0) return 'ref020-deposit-positive';
            if (d < 0) return 'ref020-deposit-negative';
            return 'ref020-deposit-zero';
        },
        csrfToken() {
            return document.querySelector('meta[name="csrf-token"]')?.content || '';
        },
    },
    methods: {
        // hot-fix #20 안건 30 (2026-05-08): 로그아웃 — POST /users/logout (CSRF 토큰)
        onLogout() {
            const form = document.getElementById('logout-form');
            if (form) form.submit();
        },
    },
};
</script>

<style scoped>
/* hot-fix #20 안건 32 (2026-05-08): 시안 5 (Compact Pro — Stripe/Apple 스타일) 적용 — 사용자 결정.
   · 흰 배경 + rgba 보더 (얇은 미세 라인)
   · 검정 텍스트 + 모노크롬 톤 (브랜드 비행기 검정 유지)
   · 도구함 = 단일 보더 그룹 (카드 패널 X)
   · 사용자 카드 = 검정 아바타 + 메타 separator dot + deposit 색상 강조 */
.ref020-header {
    background: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.ref020-header-row1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.625rem 1.25rem;
    gap: 1.25rem;
    font-size: 1rem;
}
/* hot-fix #20 안건 28 후속 fix (2026-05-08): 좌측 그룹 wrapper — brand-area + header-tools 묶음. 사이드바 collapsed 시 도구함 좌측 정렬 정합 (사용자 결정) */
.ref020-header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-shrink: 0;
}
.ref020-brand-area {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-shrink: 0;
}
.ref020-brand {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    text-decoration: none;
    color: #000;
    letter-spacing: -0.02em;
}
.ref020-brand i {
    font-style: normal;
    font-size: 1.25rem;
    color: #000;
}
.ref020-brand-name {
    font-weight: 700;
    font-size: 1.0625rem;
    color: #000;
}
.ref020-brand-tagline {
    font-size: 1rem;
    color: #6b7280;
}
.ref020-header-right {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
    justify-content: flex-end;
}
.ref020-login-info {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}
.ref020-deposit-box,
.ref020-arrears-box,
.ref020-mailbox-box {
    /* 안건 30 으로 user-card 통합되어 dead. 호환 보존 */
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 0.25rem;
    padding: 0.25rem 0.5rem;
    font-size: 1rem;
    white-space: nowrap;
}
.ref020-arrears-box {
    background: #fef3c7;
    border-color: #fcd34d;
    color: #92400e;
}

/* hot-fix #20 안건 34 (2026-05-08): 시안 D 적용 — 정보 박스 별도 그룹 + 사용자 카드 단순화 */
/* 정보 박스 그룹 (도구함과 같은 형태 — 단일 보더 + separator border-right) */
.ref020-header-info-group {
    display: inline-flex;
    align-items: stretch;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    overflow: hidden;
    background: #fff;
    flex-shrink: 0;
}
.ref020-info-box {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.4375rem 0.875rem;
    font-size: 1rem;
    font-weight: 500;
    border-right: 1px solid #e5e7eb;
    white-space: nowrap;
}
.ref020-info-box:last-child {
    border-right: 0;
}
.ref020-info-box i.material-icons {
    font-size: 1.1666rem; /* 안건 38 (2026-05-08): 14px — 시각적 존재감 강화 */
}
/* 안건 37 (2026-05-08): 예치금·미결제 클릭 링크 — 시각 변경 없음, hover 시 배경 톤만 살짝 */
a.ref020-info-link {
    text-decoration: none;
    transition: background-color 0.15s ease;
}
a.ref020-info-link:hover {
    background: #f6f8fa;
}
a.ref020-info-arrears.ref020-info-link:hover {
    background: #ffeaea;
}
.ref020-info-mailbox { color: #525866; }
.ref020-info-mailbox i.material-icons { color: #9ca3af; }
.ref020-info-deposit { font-weight: 600; }
.ref020-info-deposit.ref020-deposit-positive { color: #635bff; }
.ref020-info-deposit.ref020-deposit-positive i.material-icons { color: #635bff; }
.ref020-info-deposit.ref020-deposit-negative { color: #ad1c1c; }
.ref020-info-deposit.ref020-deposit-negative i.material-icons { color: #ef4444; }
.ref020-info-deposit.ref020-deposit-zero { color: #9ca3af; }
.ref020-info-deposit.ref020-deposit-zero i.material-icons { color: #9ca3af; }
.ref020-info-arrears {
    background: #fff5f5;
    color: #ad1c1c;
    font-weight: 600;
}
.ref020-info-arrears i.material-icons { color: #ef4444; }

/* 사용자 카드 — 단순화 (닉네임 + 아바타 + 화살표만) */
.ref020-user-card {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.25rem 0.625rem 0.25rem 0.25rem;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: background 0.15s ease;
    flex-shrink: 0;
}
.ref020-user-card:hover {
    background: #f6f8fa;
}
.ref020-user-card-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
    background: #000;
    color: #fff;
    border-radius: 9999px;
    flex-shrink: 0;
}
.ref020-user-card-avatar i.material-icons {
    font-size: 1.375rem;
}
.ref020-user-card-nick {
    font-size: 1.0625rem;
    font-weight: 600;
    color: #000;
    line-height: 1.25;
    letter-spacing: -0.01em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 16rem;
}
.ref020-user-card-caret {
    font-size: 1.25rem;
    color: #525866;
    flex-shrink: 0;
}

/* 사용자 드롭다운 패널 (uk-dropdown 안 컨텐츠) */
.ref020-user-dropdown {
    min-width: 18rem;
    padding: 0;
}
.ref020-user-dropdown-info {
    padding: 0.875rem 1rem 0.75rem;
}
.ref020-user-dropdown-nick {
    font-size: 1rem;
    font-weight: 600;
    color: #111827;
    margin-bottom: 0.125rem;
}
.ref020-user-dropdown-email {
    font-size: 1rem;
    color: #6b7280;
    margin-bottom: 0.5rem;
}
.ref020-user-dropdown-mailbox {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 1rem;
    color: #374151;
    margin-bottom: 0.375rem;
}
.ref020-user-dropdown-mailbox i.material-icons {
    font-size: 1rem;
    color: #9ca3af;
}
.ref020-user-dropdown-deposit {
    font-size: 1rem;
    font-weight: 600;
    text-align: right;
    margin-top: 0.25rem;
}
.ref020-user-dropdown-deposit.ref020-deposit-positive {
    color: #1e40af;
}
.ref020-user-dropdown-deposit.ref020-deposit-negative {
    color: #b91c1c;
}
.ref020-user-dropdown-deposit.ref020-deposit-zero {
    color: #9ca3af;
}
.ref020-user-dropdown-arrears {
    font-size: 1rem;
    color: #b45309;
    background: #fef3c7;
    border: 1px solid #fcd34d;
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    margin-top: 0.375rem;
    text-align: right;
}
.ref020-user-dropdown-divider {
    border: 0;
    border-top: 1px solid #e5e7eb;
    margin: 0;
}
.ref020-user-dropdown-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.625rem 1rem;
}
.ref020-user-dropdown-link {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    color: #1e40af;
    text-decoration: none;
    font-size: 1rem;
}
.ref020-user-dropdown-link:hover {
    color: #1e3a8a;
}
.ref020-user-dropdown-link i.material-icons {
    font-size: 1.125rem;
}
.ref020-user-dropdown-logout {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    background: #fee2e2;
    color: #991b1b;
    border: 1px solid #fecaca;
    border-radius: 0.25rem;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;
}
.ref020-user-dropdown-logout:hover {
    background: #fecaca;
    color: #7f1d1d;
}
.ref020-user-dropdown-logout i.material-icons {
    font-size: 1rem;
}

/* hot-fix #20 안건 29·32 (2026-05-08): 좌측 사이트 링크 — 단순 링크 (공지사항·결제관리). 시안 5 정합 (Stripe 스타일) */
.ref020-header-links {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    flex-shrink: 0;
}
.ref020-header-links-item {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.4375rem 0.75rem;
    color: #525866;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 500;
    border-radius: 0.375rem;
    white-space: nowrap;
    transition: all 0.15s ease;
}
.ref020-header-links-item i.material-icons {
    font-size: 1.1666rem; /* 안건 38 (2026-05-08): 텍스트(12px)보다 살짝 큰 14px — 시각적 존재감 + 정렬 유지 */
    color: #525866;
}
.ref020-header-links-item:hover {
    background: #f6f8fa;
    color: #000;
}
.ref020-header-links-item:hover i.material-icons {
    color: #000;
}

/* hot-fix #20 안건 27·29·32 (2026-05-08): 우측 도구함 — 외부 도구 + 계산기.
   시안 5 (Stripe 스타일): 단일 보더 그룹 + 흰 배경 + 모노크롬 호버. build icon 라벨 + separator. */
.ref020-header-tools {
    display: inline-flex;
    align-items: stretch;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    overflow: hidden;
    flex-shrink: 0;
    background: #fff;
}
.ref020-header-tools-label {
    /* hot-fix #20 안건 30·32 (2026-05-08): "도구" 텍스트 제거, build icon 단독 + 우측 separator 보더 */
    display: inline-flex;
    align-items: center;
    padding: 0 0.625rem;
    border-right: 1px solid #e5e7eb;
    background: #f9fafb;
}
.ref020-header-tools-label i.material-icons {
    font-size: 1.1666rem; /* 안건 38 (2026-05-08): 14px — 도구함 라벨 아이콘도 통일 */
    color: #9ca3af;
}
.ref020-header-tools-item {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.4375rem 0.875rem;
    color: #525866;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 500;
    border-right: 1px solid #e5e7eb;
    white-space: nowrap;
    transition: background 0.15s ease;
}
.ref020-header-tools-item:last-child {
    border-right: 0;
}
.ref020-header-tools-item i.material-icons {
    font-size: 1.1666rem; /* 안건 38 (2026-05-08): 14px — 시각적 존재감 강화 */
    color: #6b7280;
}
.ref020-header-tools-item:hover {
    background: #f9fafb;
    color: #000;
}
.ref020-header-tools-item:hover i.material-icons {
    color: #000;
}
</style>
